import script from "./Contacts.vue?vue&type=script&setup=true&lang=js"
export * from "./Contacts.vue?vue&type=script&setup=true&lang=js"

import "./Contacts.vue?vue&type=style&index=0&id=27fdcae0&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27fdcae0"]])

export default __exports__